export const strapiErrorMessages = {
  'Email is already taken': '邮箱地址已被使用',
  'Username already taken': '用户名已被使用',
  'Your account email is not confirmed': '你的邮箱地址还未验证',
}
